import { forwardRef } from 'react';
import { MenuItem } from '@mui/material';
import { ICMenuItem } from 'types/atoms';

const CMenuItem = forwardRef<HTMLLIElement, ICMenuItem>((props, ref) => {
  return (
    <MenuItem
      {...props}
      ref={ref}
      classes={{
        selected: '!bg-primary-100',
        root: 'text-neutral-500 hover:bg-primary-100/50 hover:text-neutral-700 aria-selected:!bg-primary-100',
      }}
    />
  );
});

export default CMenuItem;
